import { TableCard } from 'app/components'
import { DispositivosListHeader } from './components/header/DispositivosListHeader'
import { ListFiltersProvider } from './core/ListFiltersProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { DispositivosTable } from './table/DispositivosTable'

const DispositivosList = () => (
  <TableCard>
    <DispositivosListHeader />
    <DispositivosTable />
  </TableCard>
)

export const DispositivosListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListFiltersProvider>
        <DispositivosList />
      </ListFiltersProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
